import * as React from "react"
import { Box, Typography } from "@mui/material"

import { SkuLabelWrap } from "."
import CategoryLabelWrap from "./SkuLabelWrap copy"


export default function SkuInfoBlockWrap({ sku, url, category, brand, maxWidth=400,  }) {
    return <Box sx={{minWidth: "fit-content", whiteSpace: "nowrap", maxWidth: 500}}>
        <SkuLabelWrap url={url} label={sku} maxWidth={maxWidth}/>
        {!!category && <Typography variant="caption" sx={{display: "block", color: "text.disabled"}}>
            <CategoryLabelWrap label={category} maxWidth={maxWidth} />
        </Typography>}
        {!!brand && <Typography variant="caption" sx={{display: 'block', color: "text.disabled", whiteSpace: 'normal', wordBreak: 'break-word'}}>
            Brand: {brand}
        </Typography>}
    </Box>
}